import { Box } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank, NoPhotography } from '@mui/icons-material';
import { vehiclePageStyles } from '../../styles';
import ActionButton from 'components/Shared/Buttons/ActionButton';

interface PictureTileProps {
  picture?: {
    id: string;
    src: string;
  };
  isSelected: boolean;
  isMainTile?: boolean;
  canEditPictures?: boolean;
  onPictureClick: () => void;
  onCheckboxClick: (event: React.MouseEvent) => void;
  onAddPictures?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  showAddButton?: boolean;
}

export const PictureTile: React.FC<PictureTileProps> = ({
  picture,
  isSelected,
  isMainTile = false,
  canEditPictures = true,
  onPictureClick,
  onCheckboxClick,
  onAddPictures,
  showAddButton = false,
}) => {
  const tileStyles = isMainTile ? vehiclePageStyles.pictureMainTile : vehiclePageStyles.pictureGridItem;

  const checkboxIconSize = isMainTile ? 22 : 20;

  // Determine background color based on picture and tile type
  let backgroundColor: string | undefined = 'rgba(0, 0, 0, 0.03)';
  if (picture) {
    backgroundColor = isMainTile ? undefined : 'rgba(0, 0, 0, 0.05)';
  }

  return (
    <Box
      className={picture ? 'picture-grid-item-hoverable' : ''}
      sx={{
        ...tileStyles,
        ...(picture && isSelected ? vehiclePageStyles.pictureGridItemSelected : {}),
        ...(backgroundColor && { backgroundColor }),
        cursor: picture ? 'pointer' : 'default',
      }}
      onClick={onPictureClick}
    >
      {picture ? (
        <>
          <img
            src={picture.src}
            alt={picture.src}
            loading="lazy"
            style={vehiclePageStyles.pictureImage as React.CSSProperties}
          />
          {canEditPictures ? (
            <Box
              className="picture-checkbox"
              sx={{
                ...vehiclePageStyles.pictureCheckbox,
                opacity: 1,
              }}
              onClick={onCheckboxClick}
            >
              {isSelected ? (
                <CheckBox sx={{ fontSize: checkboxIconSize, color: '#fff' }} />
              ) : (
                <CheckBoxOutlineBlank sx={{ fontSize: checkboxIconSize, color: '#fff' }} />
              )}
            </Box>
          ) : null}
        </>
      ) : null}
      {!picture && showAddButton && isMainTile ? (
        <ActionButton type="add" icon={<NoPhotography sx={{ width: 50, height: 50 }} />} component="label">
          <input type="file" accept="image/png, image/jpg, image/jpeg" multiple hidden onInput={onAddPictures} />
        </ActionButton>
      ) : null}
    </Box>
  );
};
